import React from "react";
const CustomerList = React.lazy(() =>
  import("../Pages/Administration/Customer/CustomerList")
);
const PendingCustomerList = React.lazy(() =>
  import("../Pages/Administration/Customer/PendingCustomerList")
);
const TestimonialList = React.lazy(() =>
  import("../Pages/Administration/Testimonial/TestimonialList")
);
const Profile = React.lazy(() =>
  import("../Pages/Administration/Profile/Profile")
);

const Theme1 = React.lazy(() => import("../Pages/Theme/Theme1"));
const Theme2 = React.lazy(() => import("../Pages/Theme/Theme2"));
const Theme3 = React.lazy(() => import("../Pages/Theme/Theme3"));
const Theme4 = React.lazy(() => import("../Pages/Theme/Theme4"));
const Theme5 = React.lazy(() => import("../Pages/Theme/Theme5"));
const Theme6 = React.lazy(() => import("../Pages/Theme/Theme6"));
const Theme7 = React.lazy(() => import("../Pages/Theme/Theme7"));
const Member = React.lazy(() => import("../Pages/Company/Member"));
const Message = React.lazy(() => import("../Pages/Company/Message"));
const GalleryPostDetail = React.lazy(() => import("../Pages/Company/GalleryPostDetail"));
const Login = React.lazy(() => import("../Pages/Login"));
const ThemePreview = React.lazy(() => import("../Pages/Company/ThemePreview"));
const Nfc1 = React.lazy(() => import("../Pages/Nfc/Nfc1"));
const NfcPreview = React.lazy(() => import("../Pages/Company/NfcPreview"));
const NfcPreview2 = React.lazy(() => import("../Pages/Company/NfcPreview2"));
const AdministrationLogin = React.lazy(() =>
  import("../Pages/Administration/AdminLogin")
);
const Dashboard = React.lazy(() => import("../Pages/Administration/Dashboard"));
const CompanyProfile = React.lazy(() => import("../Pages/Company/Profile"));
const ViewCustomer = React.lazy(() =>
  import("../Pages/Administration/Customer/ViewCustomer")
);
const ThemeList = React.lazy(() =>
  import("../Pages/Administration/Theme/Theme")
);
const CouponList = React.lazy(() =>
  import("../Pages/Administration/Coupon/CouponList")
);
const publicRoutes = [
  { path: "/", component: Login },
  { path: "/create-account", component: Login },
];

const protectedRoutes = [{ path: "/dashboard", component: CompanyProfile },  {
  path: "/member",
  exact: true,
  component: Member,
},
{
  path: "/message",
  exact: true,
  component: Message,
},];

const adminRoutesPublic = [
  { path: "/administration", component: AdministrationLogin },
];

const adminRoutesProtected = [
  {
    path: "/administration/dashboard",
    exact: true,
    component: Dashboard,
  },
  {
    path: "/administration/customer",
    exact: true,
    component: CustomerList,
  },
  {
    path: "/administration/pending-customer",
    exact: true,
    component: PendingCustomerList,
  },
  {
    path: "/administration/customer-view",
    exact: true,
    component: ViewCustomer,
  },

  {
    path: "/administration/theme",
    exact: true,
    component: ThemeList,
  },
  {
    path: "/administration/coupons",
    exact: true,
    component: CouponList,
  },
  {
    path: "/administration/testimonials",
    exact: true,
    component: TestimonialList,
  },
  {
    path: "/administration/profile",
    exact: true,
    component: Profile,
  },
];

const themeRoutes = [
  { path: "/theme-preview-1", component: Theme1 },
  { path: "/theme-preview-2", component: Theme2 },
  { path: "/theme-preview-3", component: Theme3 },
  { path: "/profile/:domain_name", component: ThemePreview },
  { path: "/nfc-preview/:domain_name", component: NfcPreview },
  { path: "/nfc-preview-1", component: Nfc1 },
  { path: "/theme-preview-4", component: Theme4 },
  { path: "/theme-preview-5", component: Theme5 },
  { path: "/theme-preview-6", component: Theme6 },
  { path: "/theme-preview-7", component: Theme7 },
  { path: "/nfc-preview-2/:domain_name", component: NfcPreview2 },
  { path: "/gallery-post", component: GalleryPostDetail },
];

export {
  protectedRoutes,
  publicRoutes,
  adminRoutesPublic,
  adminRoutesProtected,
  themeRoutes,
};
